import './Footer.css'

const Footer = () =>
{
	
	return (
		<div className="footer-main-container" >
            <div className='footer-text'>
                Copyright © 2023 Digitalreti Srl -&nbsp;
                <a href={`${process.env.REACT_APP_SITE_URL}/privacy-policy/`} className='footer-link'>Privacy Policy</a>
            </div>
            
		</div>
	)
}

export default Footer
